import React, { useState, useEffect } from "react";
import { Button, Alert } from "react-bootstrap";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { CenterFocusStrong, VpnKey } from "@material-ui/icons";
import * as message from "../../config/CommonMessages";
import InputMask from "react-input-mask";
import { useParams } from "react-router-dom";
import UrlConstants from "../../config/UrlConstants";
import axios from "axios";
import * as code from "../../config/Constants";
import { toastMessage } from "../Common/Common";
import { useHistory, Link } from "react-router-dom";
import HeaderLogin from "../HeaderLogin/HeaderLogin";

function SetpasswordAuthenticationNew(props) {
  let history = useHistory();
  const [contact, setContacts] = useState({
    firstname: "",
    LastName: "",
    email: "",
    mobileNumber: "",
    password: "",
    confirmPassword: "",
    username: "",
    dsd: {},
  });
  const [showLoader, setShowLoader] = React.useState(false);
  const [confirm, setConfirm] = React.useState(false);
  const [readonlyMobile, setReadonlyMobile] = React.useState(false);
  const [readonlyEmail, setReadonlyEmail] = React.useState(false);
  const [duplicateUserName, setduplicateUserName] = React.useState(false);
  const [duplicateMobile, setduplicateMobile] = React.useState(false);
  const [duplicateEmail, setduplicateduplicateEmail] = React.useState(false);

  const [auth, setAuth] = React.useState("");
  const { id } = useParams();
  // console.log("id", id);

  const handleChange = (event) => {
    // console.log("event======>", event.target.name);

    // use spread operator
    if (event.target.name == "mobileNumber") {
      setContacts({
        ...contact,
        [event.target.name]: event.target.value.replace(/-/g, ""),
      });
    } else if (event.target.name == "isTextMsgEnabled") {
      const contactData = { ...contact };
      contactData.dsd[event.target.name] = event.target.checked;
      setContacts(contactData);
    } else {
      setContacts({
        ...contact,
        [event.target.name]: event.target.value,
      });
    }
  };

  const getUserByid = async () => {
    try {
      const response = await axios.get(
        `${UrlConstants.RegisterUrl}/getuserbyid/${id}`
      );
      if (response.status == 200) {
        //console.log("getUserByid response", response);
        setContacts({
          firstname:
            response.data.firstname === null ? "" : response.data.firstname,
          LastName:
            response.data.lastname === null ? "" : response.data.lastname,
          email:
            response.data.email.address === null
              ? ""
              : response.data.email.address,
          mobileNumber:
            response.data.mobileNumber === null
              ? ""
              : String(response.data.mobileNumber),
          dsd: response.data.dsd,
        });

        //console.log("email", response.data.email.address);
        let emailPrev =
          response.data.email.address === null
            ? ""
            : response.data.email.address;

        if (emailPrev) {
          //console.log("setting email readonly");
          setReadonlyEmail(true);
        }
        if (response.data.mobileNumber !== null) {
          setReadonlyMobile(true);
        }
        setAuth(response.data.authId);
        setShowLoader(false);
      } else {
        toastMessage(code.ERROR, response.error);
      }
      // console.log("response", response);
    } catch (err) {
      // console.log("i am here")
      toastMessage(code.ERROR, err);
    }
  };

  const onSubmitTOauth = async (values) => {
    // console.log("values 65", values);
    setduplicateMobile(false);
    setduplicateduplicateEmail(false);
    setduplicateUserName(false);
    setShowLoader(true);
    values._id = id;

    values.username = values.username.toLowerCase();
    values.email = values.email.toLowerCase();

    //trim the data
    values.username = values.username.trim();
    values.firstname = values.firstname.trim();
    values.LastName = values.LastName.trim();
    values.email = values.email.trim();
    values.password = values.password.trim();

    try {
      const response = await axios.post(
        `${UrlConstants.RegisterUrl}/registrationNew`,
        values
      );
      // console.log("response", response);
      if (response.status == 200) {
        if (response.data == null || response.data == "") {
          setConfirm(true);
          setAuth("true");
        } else if (response.data == "duplicate") {
          setduplicateUserName(true);
        } else if (response.data == "duplicateEmail") {
          // email id duplicate
          setduplicateduplicateEmail(true);
        } else if (response.data == "duplicateMobile") {
          // mobile is duplicate
          setduplicateMobile(true);
        }
        setShowLoader(false);
      } else {
        toastMessage(code.ERROR, response.error);
      }
      // console.log("response", response);
    } catch (err) {
      // console.log("i am here")
      toastMessage(code.ERROR, err);
    }
  };

  useEffect(() => {
    setShowLoader(true);
    getUserByid();
  }, []);
  // console.log("contavts", contact);
  // console.log("auth", auth);
  // console.log("confirm", confirm);
  // console.log("duplicateUserName", duplicateUserName);
  // console.log("duplicateMobile", duplicateMobile);
  // console.log("duplicateMobile", duplicateMobile);
  // console.log("duplicateEmail", duplicateEmail);

  return (
    <div>
      {showLoader ? (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : auth === "" ? (
        <div className="reg-page">
          <HeaderLogin />
          <div className="loginBg align-items-end flex-column">
            <div class="step-progress">
              <div class="reg-title-wrapper">
                <h4 class="title-big mt-0" style={{ padding: "20px 0" }}>
                  Register
                </h4>
              </div>
            </div>
            <div className="step-content">
              <div className="form-sm">
                <div>
                  {/* <h4>Register</h4> */}
                  <Formik
                    validateOnChange={true}
                    validateOnBlur={true}
                    initialValues={contact}
                    enableReinitialize={true}
                    validationSchema={Yup.object().shape(
                      {
                        firstname: Yup.string()
                          .trim()
                          .required(message.ENTER_FIRST_NAME)
                          .matches(new RegExp("^[A-Za-z '-]{1,50}$"), {
                            message: message.ENTER_VALID_FIRST_NAME,
                          }),

                        username: Yup.string()
                          .trim()
                          .required(message.ENTER_USER_NAME)
                          .matches(new RegExp("^[a-z][a-z0-9@._]*$"), {
                            message: message.ENTER_VALID_USER_NAME,
                          }),

                        LastName: Yup.string()
                          .trim()
                          .required(message.ENTER_LAST_NAME)
                          .matches(new RegExp("^[A-Za-z '-]{1,50}$"), {
                            message: message.ENTER_VALID_LAST_NAME,
                          }),

                        password: Yup.string()
                          .required(message.ENTER_PASSWORD)
                          .min(6, message.PASSWORD_LENGTH)
                          .matches(/^\S*$/, message.ENTER_VALID_PASSWORD),

                        confirmPassword: Yup.string()
                          .required(message.CONFIRM_PASSWORD)
                          .oneOf(
                            [Yup.ref("password"), null],
                            message.CONFIRM_PASSWORD_MATCH
                          ),

                        // email: Yup.string().when("mobileNumber", {
                        //   is: (mobileNumber) =>
                        //     !mobileNumber || mobileNumber.length === 0,
                        //   then: Yup.string()
                        //     .trim()
                        //     .matches(
                        //       new RegExp(
                        //         "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"
                        //       ),
                        //       {
                        //         message: message.ENTER_VALID_EMAIL,
                        //       }
                        //     )
                        //     .required(
                        //       "At least one of the fields either email or mobile number is required"
                        //     ),
                        // }),
                        // mobileNumber: Yup.string().when("email", {
                        //   is: (email) => !email || email.length === 0,
                        //   then: Yup.string()
                        //     .nullable()
                        //     .required(
                        //       "At least one of the fields either email or mobile number is required"
                        //     )
                        //     .test(
                        //       "mobileNumber",
                        //       message.ENTER_VALID_MOBILE,
                        //       (value) => {
                        //         if ((value || "").length == 10) {
                        //           return true;
                        //         }
                        //         return false;
                        //       }
                        //     ),
                        // }),
                        email: Yup.string()
                          .trim()
                          .matches(
                            new RegExp(
                              "^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"
                            ),
                            {
                              message: message.ENTER_VALID_EMAIL,
                            }
                          )
                          .required(message.ENTER_EMAIL),

                        mobileNumber: Yup.string()
                          .nullable()
                          .required(message.ENTER_MOBILE_NUMBER)
                          .test(
                            "mobileNumber",
                            message.ENTER_VALID_MOBILE,
                            (value) => {
                              // console.log("mobileNumber===>", value);
                              if (
                                (value || "").length === 10 &&
                                value.charAt(0) != "0"
                              ) {
                                return true;
                              }
                              return false;
                            }
                          ),
                        isTextMsgEnabled: Yup.boolean(),
                      }
                      // ["email", "mobileNumber"]
                    )}
                    onSubmit={(values) => {
                      onSubmitTOauth(values);
                      // console.log("values", values);
                    }}
                  >
                    {({ errors, values, touched }) => (
                      <Form>
                        <div className="row">
                          <div className="col-sm-6 col-12">
                            <div className="form-group">
                              <label className="form-label" htmlFor="password">
                                Username{" "}
                                <span style={{ color: "white" }}> *</span>
                              </label>
                              <div className="icon-wrapper input-group">
                                <Field
                                  type="text"
                                  name="username"
                                  onChange={handleChange}
                                  className={
                                    "form-control form-control-lg" +
                                    (errors.firstname && touched.firstname
                                      ? " is-invalid"
                                      : errors.firstname
                                      ? "is-invalid"
                                      : "")
                                  }
                                />
                              </div>
                              {errors.username && touched.username ? (
                                <div style={{ color: "white" }}>
                                  {errors.username}
                                </div>
                              ) : errors.username ? (
                                <div style={{ color: "white" }}>
                                  {errors.username}
                                </div>
                              ) : null}
                              {duplicateUserName ? (
                                <div style={{ color: "white" }}>
                                  Username already present
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6 col-12">
                            <div className="form-group">
                              <label className="form-label" htmlFor="password">
                                Password{" "}
                                <span style={{ color: "white" }}> *</span>
                              </label>
                              <div className="icon-wrapper input-group">
                                <Field
                                  type="password"
                                  name="password"
                                  onChange={handleChange}
                                  className={
                                    "form-control form-control-lg" +
                                    (errors.password && touched.password
                                      ? " is-invalid"
                                      : errors.password
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </div>
                              {errors.password && touched.password ? (
                                <div style={{ color: "white" }}>
                                  {errors.password}
                                </div>
                              ) : errors.password ? (
                                <div style={{ color: "white" }}>
                                  {errors.password}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="form-group">
                              <label
                                className="form-label"
                                htmlFor="confirmPassword"
                              >
                                Confirm Password{" "}
                                <span style={{ color: "white" }}> *</span>
                              </label>
                              <div className="icon-wrapper input-group">
                                <Field
                                  type="password"
                                  name="confirmPassword"
                                  onChange={handleChange}
                                  className={
                                    "form-control form-control-lg" +
                                    (errors.confirmPassword &&
                                    touched.confirmPassword
                                      ? "is-invalid"
                                      : errors.confirmPassword
                                      ? "is-invalid"
                                      : "")
                                  }
                                />
                              </div>
                              {errors.confirmPassword &&
                              touched.confirmPassword ? (
                                <div style={{ color: "white" }}>
                                  {errors.confirmPassword}
                                </div>
                              ) : errors.confirmPassword ? (
                                <div style={{ color: "white" }}>
                                  {errors.confirmPassword}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6 col-12">
                            <div className="form-group">
                              <label className="form-label" htmlFor="password">
                                First Name{" "}
                                <span style={{ color: "white" }}> *</span>
                              </label>
                              <div className="icon-wrapper input-group">
                                <Field
                                  type="text"
                                  name="firstname"
                                  onChange={handleChange}
                                  className={
                                    "field_ucfirst form-control form-control-lg" +
                                    (errors.firstname && touched.firstname
                                      ? " is-invalid"
                                      : errors.firstname
                                      ? "is-invalid"
                                      : "")
                                  }
                                />
                              </div>
                              {errors.firstname && touched.firstname ? (
                                <div style={{ color: "white" }}>
                                  {errors.firstname}
                                </div>
                              ) : errors.firstname ? (
                                <div style={{ color: "white" }}>
                                  {errors.firstname}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="form-group">
                              <label className="form-label" htmlFor="password">
                                Last Name{" "}
                                <span style={{ color: "white" }}> *</span>
                              </label>
                              <div className="icon-wrapper input-group">
                                <Field
                                  type="text"
                                  name="LastName"
                                  onChange={handleChange}
                                  className={
                                    "field_ucfirst form-control form-control-lg" +
                                    (errors.LastName && touched.LastName
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </div>
                              {errors.LastName && touched.LastName ? (
                                <div style={{ color: "white" }}>
                                  {errors.LastName}
                                </div>
                              ) : errors.LastName ? (
                                <div style={{ color: "white" }}>
                                  {errors.LastName}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6 col-12">
                            <div className="form-group">
                              <label className="form-label" htmlFor="password">
                                Email <span style={{ color: "white" }}> *</span>
                              </label>

                              <div className="icon-wrapper input-group">
                                <Field
                                  type="email"
                                  name="email"
                                  onChange={handleChange}
                                  value={values.email}
                                  readOnly={readonlyEmail}
                                  className={
                                    "form-control form-control-lg" +
                                    (errors.email && touched.email
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </div>
                              {errors.email && touched.email ? (
                                <div style={{ color: "white" }}>
                                  {errors.email}
                                </div>
                              ) : errors.email ? (
                                <div style={{ color: "white" }}>
                                  {errors.email}
                                </div>
                              ) : null}

                              {duplicateEmail ? (
                                <div style={{ color: "white" }}>
                                  Email is already exists
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="form-group">
                              <label className="form-label" htmlFor="password">
                                Mobile Number{" "}
                                <span style={{ color: "white" }}> *</span>
                              </label>
                              {/* {values.mobileNumber == "" ? "true" : "false"} */}
                              <div className="icon-wrapper input-group">
                                <InputMask
                                  mask="999-999-9999"
                                  maskChar=""
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                  value={values.mobileNumber}
                                  readOnly={readonlyMobile}
                                  className="form-control form-control-lg"
                                  name="mobileNumber"
                                  onChange={handleChange}
                                />
                              </div>
                              {errors.mobileNumber && touched.mobileNumber ? (
                                <div style={{ color: "white" }}>
                                  {errors.mobileNumber}
                                </div>
                              ) : errors.mobileNumber ? (
                                <div style={{ color: "white" }}>
                                  {errors.mobileNumber}
                                </div>
                              ) : null}
                              {duplicateMobile ? (
                                <div style={{ color: "white" }}>
                                  Mobile number is already exists
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          {values.dsd &&
                            values.dsd.roles &&
                            values.dsd.roles.length > 0 &&
                            values.dsd.roles[0].roleName === "Client" && (
                              <div className="col-12">
                                <div className="form-group custom-control custom-checkbox custom-control-inline custom-privacy bg-white mt-2">
                                  <input
                                    value={values.dsd.isTextMsgEnabled}
                                    checked={values.dsd.isTextMsgEnabled}
                                    type="checkbox"
                                    className="custom-control-input green-checkbox"
                                    id="isTextMsgEnabled"
                                    name="isTextMsgEnabled"
                                    onChange={handleChange}
                                  />
                                  <label
                                    className="custom-control-label f-10"
                                    htmlFor="isTextMsgEnabled"
                                  >
                                    Opted In to receive text Messages
                                  </label>
                                </div>
                              </div>
                            )}
                        </div>
                        <div className="row">
                          <div className="col-md-4 col-sm-12 col-3 offset-md-4">
                            <div className="form-group pt-2">
                              <Button
                                type="submit"
                                variant="primary"
                                size="lg"
                                block
                                className="btn-blue btn-medium"
                              >
                                Submit
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : confirm ? (
        <div>
          <div>
            <HeaderLogin />
            <div className="loginBg loginContent align-items-end flex-column">
              <div className="step-content">
                <div className="form-sm" style={{ textAlign: "center" }}>
                  <div role="alert" class="fade alert alert-success show">
                    Thank you for registration..
                  </div>{" "}
                  <Link style={{ color: "white" }} to="/login">
                    Click here to go to login
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <HeaderLogin />
          <div className="loginBg loginContent align-items-end flex-column">
            <div className="step-content">
              <div className="form-sm">
                <div role="alert" class="fade alert alert-success show">
                  Already registered !
                </div>{" "}
                <Link style={{ color: "white" }} to="/login">
                  Click here to go to login
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SetpasswordAuthenticationNew;
